import * as types from '../constants/actionTypes';
import axios from 'axios/index';
import {receiveSavedItems} from "./shoppingCartActions";

// example of a thunk using the redux-thunk middleware
export function requestProducts() {
  return function (dispatch) {
    // thunks allow for pre-processing actions, calling apis, and dispatching multiple actions
    // in this case at this point we could call a service that would persist the fuel savings
    return dispatch({
      type: types.REQUEST_PRODUCTS
    });
  };
}

export function receiveProducts(data) {
  return {
    type: types.RECEIVE_PRODUCTS,
    data
  };
}

export function fetchProducts(params = {}) {
  // Thunk middleware knows how to handle functions.
  // It passes the dispatch method as an argument to the function,
  // thus making it able to dispatch actions itself.

  return function (dispatch) {
    // First dispatch: the app state is updated to inform
    // that the API call is starting.

    dispatch(requestProducts());

    // The function called by the thunk middleware can return a value,
    // that is passed on as the return value of the dispatch method.

    // In this case, we return a promise to wait for.
    // This is not required by thunk middleware, but it is convenient for us.


    return axios.get(`${ROOT_URL}/api/get-products`, {
      params,
      withCredentials: true
    }).then(response => {
      dispatch(receiveProducts(response.data));
    });
  };
}

export function requestFilters() {
  return function (dispatch) {
    return dispatch({
      type: types.REQUEST_FILTERS
    });
  };
}

export function receiveFilters(data) {
  return {
    type: types.RECEIVE_FILTERS,
    data
  };
}

export function fetchFilters(params = {}) {
  return function (dispatch) {
    dispatch(requestFilters());

    return axios.get(`${ROOT_URL}/api/get-product-filters`, {
      params,
      withCredentials: true
    }).then(response => {
      dispatch(receiveFilters(response.data));
    });
  };
}

export function addSavedPrinter(id, name, brandId) {
  axios.post(`${ROOT_URL}/api/add-saved-printer`, {id, name, brandId}, {
    withCredentials: true
  });

  return {
    type: types.UPDATE_PRODUCTS_PRINTER,
    isSaved: true
  };
}

export function removeSavedPrinter(id) {
  axios.post(`${ROOT_URL}/api/delete-saved-printer`, {id}, {
    withCredentials: true
  });

  return {
    type: types.UPDATE_PRODUCTS_PRINTER,
    isSaved: false
  };
}

export function addToMyProducts(id) {
  return dispatch => {
    dispatch({
      type: types.UPDATE_PRODUCTS,
      data: { isSaved: true, id },
    });

    axios.post(`${ROOT_URL}/api/add-to-my-products?id=${id}`, { id }, {
      withCredentials: true
    }).catch(() => {
      // if there is a failure, this means the user is not logged in
      window.location.href = '/sign-in?returnUrl=' + encodeURIComponent(window.location.href.replace(window.location.origin, '') + window.location.hash);
    });
  };
}

export function removeFromMyProducts(id) {
  return dispatch => {
    dispatch({
      type: types.UPDATE_PRODUCTS,
      data: { isSaved: false, id },
    });

    return axios.post(`${ROOT_URL}/api/remove-from-my-products?id=${id}`, {id}, {
      withCredentials: true
    });
  };
}

